module.exports = __webpack_public_path__ + "static/media/icon_tip_dark.ba94d4a7.svg";